import React, { useEffect, useState } from "react";
import { Row, Col, Table } from "react-bootstrap";
import SideBar from "../navigation/sidebar/SideBar";
import NavBar from "../navigation/topnav/NavBar";
import RowTitles from "../components/RowTitles";
import { MdOutlineStackedLineChart } from "react-icons/md";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import { PiListNumbersLight } from "react-icons/pi";
import { BsUpcScan } from "react-icons/bs";
import Loader from "../gif/loader.gif";
import { Link } from "react-router-dom"; // Import Link from react-router-dom;
import axios from "axios";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import "bootstrap/dist/css/bootstrap.min.css";

// Register the necessary components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const ReportHome = () => {
  //states
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [rate, setRate] = useState();
  const [mem, setMem] = useState();
  const [att, setAtt] = useState();
  // Example data for the graph
  const data = {
    labels: events.map((item) => item.event_title),
    datasets: [
      {
        label: "Attendees",
        data: events.map((item) => item.attendance),
        borderColor: "rgba(75,192,192,1)",
        fill: false,
      },
    ],
  };

  const options = {
    scales: {
      y: {
        beginAtZero: true,
        // ticks: {
        //   stepSize: 10,
        // },
      },
    },
  };
  const loadEvents = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-getevents`
      );
      let retcode = res.data;
      //console.log(retcode);
      setEvents(retcode);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get calendar events error =>" + error);
    }
  };
  const getStats = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `https://ntcapi-a4fdbbdfb3gactbd.southafricanorth-01.azurewebsites.net/api/get-report_stats`
      );
      let retcode = res.data;
      setRate(retcode[0].rate);
      setMem(retcode[0].total_mem);
      setAtt(retcode[0].total_att);
      //stop loading
      setLoading(false);
    } catch (error) {
      //stop loading
      setLoading(false);
      console.log("get calendar events error =>" + error);
    }
  };
  useEffect(() => {
    loadEvents();
    getStats();
  }, []);
  return (
    <div className="d-flex" style={{ backgroundColor: "#f1f5f7" }}>
      <SideBar />
      {/* Main Content */}
      <div className="flex-grow-1">
        <NavBar />
        <div className="container-fluid mt-4">
          <Row>
            <h5>Attandance report</h5>
          </Row>
          <div className="container-fluid mt-3">
            <div className="row">
              <Col md={8}>
                <Line data={data} options={options} />
              </Col>
              <Col md={4}>
                <div
                  className="p-3 mb-4 text-secondary"
                  style={{
                    color: "white",
                    borderRadius: 15,
                  }}
                >
                  <div className="row">
                    <div className="col-9 mb-3">
                      <small style={{ fontSize: 14 }}>Attandance rate</small>{" "}
                    </div>
                    <div className="col-3">
                      <MdOutlineStackedLineChart
                        size={27}
                        style={{ color: "#3bc0c3" }}
                      />
                    </div>
                  </div>
                  <h4 style={{ marginTop: "-10px", color: "#3bc0c3" }}>
                    {rate}%
                  </h4>
                </div>
                <div
                  className="p-3 mb-4 text-secondary"
                  style={{
                    color: "white",
                    borderRadius: 15,
                  }}
                >
                  <div className="row">
                    <div className="col-9 mb-3">
                      <small style={{ fontSize: 14 }}>
                        Number of attandees
                      </small>{" "}
                    </div>
                    <div className="col-3">
                      <RiBarChartHorizontalLine
                        size={27}
                        style={{ color: "#3bc0c3" }}
                      />
                    </div>
                  </div>
                  <h4 style={{ marginTop: "-10px", color: "#3bc0c3" }}>
                    {att}
                  </h4>
                </div>
                <div
                  className="p-3 mb-4 text-secondary"
                  style={{
                    color: "white",
                    borderRadius: 15,
                  }}
                >
                  <div className="row">
                    <div className="col-9 mb-3">
                      <small style={{ fontSize: 14 }}>Registered members</small>{" "}
                    </div>
                    <div className="col-3">
                      <PiListNumbersLight
                        size={27}
                        style={{ color: "#3bc0c3" }}
                      />
                    </div>
                  </div>
                  <h4 style={{ marginTop: "-10px", color: "#3bc0c3" }}>
                    {mem}
                  </h4>
                </div>
              </Col>
            </div>
          </div>
          <RowTitles title={"Dashboad"} child={"Event list"} />
          <div className="container-fluid">
            <Table striped bordered hover className="shadow">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>date</th>
                  <th>Attandees</th>
                  <th>Non Comers</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <img src={Loader} alt="QR Code" width={"50"} height={"50"} />
                ) : (
                  events.map((item, key) => (
                    <tr>
                      <td>
                        <small>
                          <b style={{ textTransform: "uppercase" }}>
                            {item.event_title}
                          </b>
                        </small>
                      </td>
                      <td>
                        <small>{item.date}</small>
                      </td>
                      <td>
                        <small>
                          <b>{item.attendance}</b>
                        </small>
                      </td>
                      <td>
                        <small>{item.not_attended}</small>
                      </td>
                      <td>
                        <Link
                          to={`/attandance_list/${item.event_title}`}
                          className="p-3 w-100 text-dark mb-3"
                          type="submit"
                          style={{
                            backgroundColor: "#3bc0c3",
                            border: "none",
                            fontWeight: "bold",
                            fontSize: 14,
                          }}
                        >
                          <BsUpcScan className="me-2" size={20} />
                          SEE LIST
                        </Link>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReportHome;
